import { render } from "./Authenticate.vue?vue&type=template&id=7a55b2cd&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"

import "./Authenticate.vue?vue&type=style&index=0&id=7a55b2cd&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a55b2cd"]])

export default __exports__